import React, { useState, useEffect } from 'react';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { SHARE_SITES } from 'react-add-to-calendar-hoc';

import { useDispatch, useSelector } from 'react-redux';
import {
  useInjectReducer,
  useInjectSaga,
} from '../../../../utils/redux-injectors';

import TagManager from 'react-gtm-module';
import { selectProfile } from 'store/profile/selectors';
import { selectIsAuthenticated } from 'store/app/selectors';

// @ts-ignore
import Pdf from '../../../../assets/default/sample.pdf';

// locales
import { useTranslation } from 'react-i18next';
import { translations } from 'locales/i18n';

// store
import {
  actions as favoritesActions,
  reducer as favoritesReducer,
  sliceKey as favoritesSliceKey,
} from '../../../../store/favorites/slice';

import {
  reducer as appReducer,
  sliceKey as appSliceKey,
} from '../../../../store/app/slice';

import { favoritesSaga } from '../../../../store/favorites/saga';

// components
import SaveButton, { SaveToggleStyles } from '../../../../atoms/SaveToggle';

// types
import { ICardsListItemProps } from './types';
import { PagesTypes } from '../../../../types/pages';
import {
  ButtonGroups,
  ButtonSizes,
  ButtonTypes,
} from '../../../../atoms/Button/types';

// images
import { ReactComponent as WebinarDefaultBackground } from '../../../../assets/icons/bg.svg';
// import { ReactComponent as WebinarTime } from '../../../../assets/icons/carbon_time.svg';
// import { ReactComponent as DefaultSpeaker } from '../../../../assets/images/default-speaker.svg';

// styles
import {
  WebinarWrapper,
  WebinarListItem,
  WebinarImageWrapper,
  WebinarHover,
  WebinarImage,
  WebinarDuration,
  WebinarAddToCalendarButton,
  WebinarInfo,
  WebinarMeta,
  WebinarTags,
  WebinarTag,
  WebinarTagItem,
  WebinarInner,
  WebinarTitle,
  WebinarLiveLabel,
  WebinarLiveAnimation,
  WebinarSeoWrapper,
} from './styles';
import Button from '../../../../atoms/Button';

import _ from 'lodash';
import moment from 'moment';
import SaveButtonWebinar from '../../../../atoms/SaveToggleWebinar';
import { VideoPreviewItem } from '../../../../containers/VideoLibraryPage/styles';
import { ReactComponent as DurationWebinarIcon } from '../../../../assets/icons/duration-time-icon.svg';
import LiveLabel from '../../../../atoms/LiveLabel';

export const CardsListItemWebinar = ({
  type,
  data,
  clickAction,
}: ICardsListItemProps) => {
  // inject reducer && saga
  useInjectSaga({ key: favoritesSliceKey, saga: favoritesSaga });
  useInjectReducer({ key: favoritesSliceKey, reducer: favoritesReducer });
  useInjectReducer({ key: appSliceKey, reducer: appReducer });

  const [isBtnActive, setBtnActive] = useState(data['in_favorite']);

  // useEffect(() => {
  //  setBtnActive(data['in_favorite']);
  // }, []);
  // console.log('data', data)

  // locales hook
  const { t } = useTranslation();

  // route hook
  const { path } = useRouteMatch();

  // history hook
  const history = useHistory();

  // location hook
  const location = useLocation();

  // dispatch
  const dispatch = useDispatch();
  const addToFavorites = payload =>
    dispatch(favoritesActions.fetchAddTrigger(payload));

  const removeFromFavorites = payload =>
    dispatch(favoritesActions.fetchRemoveTrigger(payload));

  // selectors
  const profileInfo = useSelector(selectProfile);
  const isLoggedIn = useSelector(selectIsAuthenticated);

  const {
    id,
    title,
    description,
    short_description,
    slug,
    image,
    system_datetime_from,
    system_datetime_to,
    url,
    teaser_bg_color,
    tags,
    promotional,
  } = data;

  const items = [SHARE_SITES.GOOGLE, SHARE_SITES.OUTLOOK, SHARE_SITES.ICAL];
  const ref = React.createRef();

  const handleSave = id => {
    let payload = { webinarId: id };
    if (isLoggedIn) {
      if (isBtnActive) {
        removeFromFavorites(payload);
      } else {
        addToFavorites(payload);
      }

      setBtnActive(!isBtnActive);
    } else {
      history.push('/login', { background: location });
    }
  };

  const duration = moment(system_datetime_to).diff(
    moment(system_datetime_from),
    'minutes',
  );

  const isLiveWebinar =
    parseInt(moment(system_datetime_from).format('X')) <= moment().unix() &&
    parseInt(moment(system_datetime_to).format('X')) >= moment().unix();

  const isPastWebinar =
    parseInt(moment(system_datetime_from).format('X')) <= moment().unix();

  const startDatetime = new Date(system_datetime_from);
  const endDatetime = new Date(system_datetime_to);
  const eventDuration = startDatetime.getHours() - endDatetime.getHours();
  const event = {
    title: title,
    description: description,
    // location: "Georgia - Sakartvelo",
    duration: eventDuration,
    endDatetime: moment(endDatetime).format('YYYYMMDDTHHmmssZ'),
    startDatetime: moment(startDatetime).format('YYYYMMDDTHHmmssZ'),
  };

  return (
    <WebinarListItem teaser_bg_color={teaser_bg_color}>
      <WebinarImageWrapper>
        <WebinarImage
          to={{
            pathname: promotional
              ? `${process.env.REACT_APP_BASE_PROMO_URL}webinars/${slug}`
              : `/webinars/${slug}`,
          }}
          target={promotional ? '_blank' : '_self'}
        >
          {image ? (
            <img
              src={process.env.REACT_APP_API_BASE_URL + image}
              alt="Вебінар"
            />
          ) : (
            <>
              {url ? (
                <VideoPreviewItem url={url} width="100%" height="100%" light />
              ) : (
                <WebinarDefaultBackground />
              )}
            </>
          )}

          {!isLiveWebinar && (
            <WebinarDuration>
              <DurationWebinarIcon /> {duration} хв
            </WebinarDuration>
          )}

          {isLiveWebinar && (
            <WebinarLiveAnimation>
              <LiveLabel />
            </WebinarLiveAnimation>
          )}

          <WebinarHover teaser_bg_color={teaser_bg_color} />
        </WebinarImage>
        {!isPastWebinar && (
          <WebinarAddToCalendarButton
            event={event}
            items={items}
            buttonText={'додати в календар'}
            teaser_bg_color={teaser_bg_color}
            // onRequestClose={handleClick}
            ref={ref}
          />
        )}
      </WebinarImageWrapper>
      <WebinarInner>
        <WebinarInfo>
          <WebinarTitle
            to={{
              pathname: promotional
                ? `${process.env.REACT_APP_BASE_PROMO_URL}webinars/${slug}`
                : `/webinars/${slug}`,
            }}
            target={promotional ? '_blank' : '_self'}
          >
            <WebinarSeoWrapper>{title}</WebinarSeoWrapper>
          </WebinarTitle>
          {isLiveWebinar && (
            <WebinarLiveLabel>
              <div className="in-live">Зараз у прямому ефірі</div>
            </WebinarLiveLabel>
          )}
        </WebinarInfo>
        <WebinarMeta>
          <WebinarTags>
            {tags && clickAction
              ? tags['data'].map(item => (
                  <WebinarTag key={item.id}>
                    <WebinarTagItem onClick={() => clickAction(item.id)}>
                      {item.title}
                    </WebinarTagItem>
                  </WebinarTag>
                ))
              : tags['data'].map(item => (
                  <WebinarTag key={item.id}>
                    <WebinarTagItem>{item.title}</WebinarTagItem>
                  </WebinarTag>
                ))}
          </WebinarTags>
          {!promotional && (
            <SaveButtonWebinar
              active={isBtnActive}
              click={() => handleSave(id)}
              colorType={SaveToggleStyles.Default}
            />
          )}
        </WebinarMeta>
      </WebinarInner>
    </WebinarListItem>
  );
};

export default CardsListItemWebinar;
